import React from 'react';
import { FormattedMessage } from 'react-intl';

import { imgLinks } from '../../../../shared';

import { StyledDaDirektPetCrossSellingCardImage } from './DaDirektPetCard.styled';
import {
  StyledDaDirektCrossSellingCard,
  StyledDaDirektCrossSellingCardButton,
  StyledDaDirektCrossSellingCardContent,
  StyledDaDirektCrossSellingCardDaDirektLogo,
  StyledDaDirektCrossSellingCardLogoAndImage,
  StyledDaDirektCrossSellingCardText,
  StyledDaDirektCrossSellingCardTitle,
} from '../DaDirektCrossSellingCard.styled';

const DA_DIREKT_LOGO_LINK = imgLinks['icon.menu.dadirekt.dark'];
const DA_DIREKT_PET_BG_IMAGE_DESKTOP = imgLinks['image-da-pet-cross-selling-desktop'];

function DaDirektPetCardDesktop({ onGoToCrossSellingLink }) {
  return (
    <StyledDaDirektCrossSellingCard product="pet">
      <StyledDaDirektCrossSellingCardContent>
        <StyledDaDirektCrossSellingCardTitle>
          <FormattedMessage id="promotion.carousel.da_direkt.pet.cross_selling.title.desktop" />
        </StyledDaDirektCrossSellingCardTitle>

        <div>
          <StyledDaDirektCrossSellingCardText>
            <FormattedMessage id="promotion.carousel.da_direkt.pet.cross_selling.text.desktop" />
          </StyledDaDirektCrossSellingCardText>

          <StyledDaDirektCrossSellingCardButton onClick={onGoToCrossSellingLink}>
            <FormattedMessage id="promotion.carousel.da_direkt.cross_selling.button.label" />
          </StyledDaDirektCrossSellingCardButton>
        </div>
      </StyledDaDirektCrossSellingCardContent>

      <StyledDaDirektCrossSellingCardLogoAndImage>
        <StyledDaDirektCrossSellingCardDaDirektLogo
          src={DA_DIREKT_LOGO_LINK}
          alt="DA Direkt logo"
        />

        <StyledDaDirektPetCrossSellingCardImage
          src={DA_DIREKT_PET_BG_IMAGE_DESKTOP}
          alt="DA Direkt pet"
        />
      </StyledDaDirektCrossSellingCardLogoAndImage>
    </StyledDaDirektCrossSellingCard>
  );
}

export default DaDirektPetCardDesktop;
